import {
  Search,
  Handshake,
  FileText,
  ShieldCheck,
  Route,
  Phone,
} from "lucide-react";
import { SERVICES } from "@/lib/siteContent";

const ICONS = { Search, Handshake, FileText, ShieldCheck, Route, Phone };

const ServiceCard = ({ s, isRightAtMd, isRightAtLg }) => {
  const Icon = ICONS[s.icon];
  return (
    <div
      data-testid="service-card"
      className={`p-8 lg:p-10 border-[#E5E7EB] transition-colors duration-300 hover:bg-[#F9FAFB] group
        ${isRightAtMd ? "" : "md:border-r md:border-[#E5E7EB]"}
        ${isRightAtLg ? "lg:border-r-0" : "lg:border-r lg:border-[#E5E7EB]"}
      `}
    >
      <Icon
        className="h-7 w-7 text-[#0F2A44] mb-6 transition-colors group-hover:text-[#D4AF7F]"
        strokeWidth={1.25}
      />
      <h3 className="font-serif text-xl sm:text-2xl text-[#0F2A44] mb-3 leading-snug">
        {s.title}
      </h3>
      <p className="text-[#1A1A1A]/75 leading-relaxed">{s.description}</p>
    </div>
  );
};

export const Services = () => {
  // Split into two rows of three (lg). At md, layout reflows to 2 cols cleanly.
  const row1 = SERVICES.slice(0, 3);
  const row2 = SERVICES.slice(3, 6);

  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32 border-t border-[#E5E7EB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 lg:mb-20">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-6">
              What we do
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight leading-tight text-[#0F2A44]">
              Every part of the back office,
              <span className="italic"> handled.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#1A1A1A]/75 leading-relaxed text-base sm:text-lg">
              Dispatch is more than booking a load. It's the negotiation, the
              paperwork, the broker setup, and the follow-through. We cover all of it
              so you can spend your day in the seat — not on the phone.
            </p>
          </div>
        </div>

        {/* Border-top frames the grid; an explicit hr separates row 1 from row 2 */}
        <div
          data-testid="services-grid"
          className="border-t border-[#E5E7EB] divide-y divide-[#E5E7EB]"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {row1.map((s, i) => (
              <ServiceCard
                key={s.title}
                s={s}
                isRightAtMd={i === row1.length - 1 && i % 2 === 1}
                isRightAtLg={i === row1.length - 1}
              />
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {row2.map((s, i) => (
              <ServiceCard
                key={s.title}
                s={s}
                isRightAtMd={i === row2.length - 1 && i % 2 === 1}
                isRightAtLg={i === row2.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
